import { Button, Card, Form, Input, Loader } from 'semantic-ui-react'
import BackLink from '../components/BackLink'
import BottomButton from '../components/BottomButton'
import Flexbox from 'flexbox-react'
import Layout from '../components/Layout'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import React from 'react'
import _ from 'lodash'
import { compose } from 'recompose'
import headerStyles from '../styles/header'
import injectSheet from 'react-jss'
import { withRouter } from 'react-router'

const sharedStyles = {
	description: {
		'margin-left': '5px',
		'margin-bottom': '10px !important'
	}
}
function ContinuingRaw({ log, exercise, classes }) {
	return (
		<div>
			<h2 className={classes.pageHeader}>Awesome!</h2>
			<BackLink to="/" content="Done working out" icon="check" />
			<p className={classes.description}>
				You just did {log && log.metrics ? log.metrics.reps : ''}
				{' '} {exercise.title}! Pick your next exercise
			</p>
		</div>
	)
}
ContinuingRaw.propTypes = {
	classes: PropTypes.object.isRequired,
	log: PropTypes.object.isRequired,
	exercise: PropTypes.object.isRequired
}
const Continuing = injectSheet(_.assign({}, headerStyles, sharedStyles))(ContinuingRaw)

const pickStyles = {
	exerciseGroup: {
		margin: '0 !important'
	},

	exercise: {
		margin: '0.5em !important',
		width: 'calc(50% - 1em) !important'
	},

	exerciseImage: {
		width: '100%'
	},

	exerciseButton: {
		'border-top-left-radius': '0 !important',
		'border-top-right-radius': '0 !important',
		width: '100%',
		'border-rarius': 0,
		'white-space': 'nowrap',
		overflow: 'hidden',
		'font-size': '1.2em !important',
		height: '2.6em !important',
		'text-overflow': 'ellipsis'
	},

	exerciseContent: {
		'border-top': '0 !important',
		padding: '0 !important'
	},

	customExerciseInput: {
		'font-size': '2em !important',
		height: '15vh',
		'border-radius': '0 !important',
		margin: '0',
		width: '100%'
	},

	topSticker: {
		'border-bottom': '1px solid #e0e1e2'
	}
}

function Pick({
	history,
	classes,
	loading,
	recentLog,
	recentExercise,
	exercises,
	other,
	setOther,
	submittingOther,
	setSubmittingOther,
	createExercise
}) {
	// eslint-disable-next-line no-process-env
	const functionBase = process.env.REACT_APP_FIREBASE_functionBase
	function goOtherExercise({ title, push }) {
		fetch(`${functionBase}findCloseEnoughExercise`, {
			method: 'POST',
			body: JSON.stringify({ title })
		})
			.then(response => response.json())
			.then(existingExerciseId => {
				if (existingExerciseId) {
					push(`/do/${existingExerciseId}`)
				} else {
					createExercise().then(newExerciseId => push(`/do/${newExerciseId}`))
				}
			})
	}

	const exercisesEl = (
		<Card.Group itemsPerRow={2} className={classes.exerciseGroup}>
			{_.map(exercises, (ex, id) =>
				<Card key={id} className={classes.exercise} as={Link} to={`/do/${id}`}>
					<img
						className={classes.exerciseImage}
						src={
							ex.repCloudinaryVideoPublicId
								? `https://res.cloudinary.com/zinid/video/upload/c_fill,h_160,q_auto:good,w_160/v1498833723/${ex.repCloudinaryVideoPublicId}.jpg`
								: '/img/shoe-tie-thumb.jpg'
						}
						alt={ex.title}
					/>
					<Card.Content className={classes.exerciseContent}>
						<Button className={classes.exerciseButton} primary content={ex.title} />
					</Card.Content>
				</Card>
			)}
		</Card.Group>
	)
	const starting = (
		<div>
			<Flexbox>
				<h2 className={classes.pageHeader}>Welcome back!</h2>
				<BackLink to="/" content="Cancel workout" />
			</Flexbox>
			<p className={classes.description}>
				What would you like to start your workout with?
			</p>
		</div>
	)

	return (
		<Layout.Container>
			<Layout.Sticker className={classes.topSticker}>
				{recentLog && recentExercise
					? <Continuing log={recentLog} exercise={recentExercise} />
					: starting}
			</Layout.Sticker>
			<Layout.Viewer>
				{loading
					? <Loader active inline content="Loading" />
					: <div>
							{exercisesEl}
							<Form
								loading={submittingOther}
								onSubmit={ev => {
									ev.preventDefault()
									setSubmittingOther(true)
									goOtherExercise({ push: history.push, title: other })
								}}
							>
								<Input
									className={classes.customExerciseInput}
									placeholder="Custom exercise name"
									value={other}
									onChange={(ev, el) => {
										setOther(el.value)
									}}
								/>
								<BottomButton content={`Do ${other || 'Custom'}`} />
							</Form>
						</div>}
			</Layout.Viewer>
		</Layout.Container>
	)
}
Pick.propTypes = {
	history: PropTypes.object.isRequired /* Compose ... */,
	classes: PropTypes.object.isRequired,
	loading: PropTypes.bool /* Container ... */,
	recentLog: PropTypes.object,
	recentExercise: PropTypes.object,
	exercises: PropTypes.object,
	other: PropTypes.string,
	setOther: PropTypes.func.isRequired,
	submittingOther: PropTypes.bool,
	setSubmittingOther: PropTypes.func.isRequired,
	createExercise: PropTypes.func.isRequired
}
export default compose(
	withRouter,
	injectSheet(_.assign({}, headerStyles, sharedStyles, pickStyles))
)(Pick)



// WEBPACK FOOTER //
// ./src/pages/Pick.js